/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ad7f31f2 (Tue Mar  3 17:44:55 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The possible values of where this invitation is coming from it can be form team or family
 * @export
 * @enum {string}
 */
export enum InvitationType {
  Team = 'team',
  Family = 'family',
}

export function InvitationTypeFromJSON(json: any): InvitationType {
  return InvitationTypeFromJSONTyped(json, false)
}

export function InvitationTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InvitationType {
  return json as InvitationType
}

export function InvitationTypeToJSON(value?: InvitationType | null): any {
  return value as any
}
